import { isYleEmbed, readCookie } from "../helpers/commonUtils";
import { getJson } from "../helpers/request";
import { yleTunnusSDKExists } from "../helpers/yleTunnus";
import { ReferenceItem } from "../types/common";
import { ImageObject } from "../types/player-api";

const recommendationsUrl = (programId: string) =>
  `${__PLAYER_API}/v2/recommendations/${programId}.json`;

const numberOfRecommendations = 4;

const isFinOrSwe = (language: string): language is LanguageCode =>
  language === "fin" || language === "swe";

type LanguageCode = "fin" | "swe";

const getLanguageCode = (lang: string): LanguageCode =>
  isFinOrSwe(lang) ? lang : "fin";

const queryOptions = (programId: string, language: LanguageCode) => {
  const yleSelva = readCookie("yle_selva");
  return {
    parameters: {
      language,
      limit: numberOfRecommendations,
      ...(yleSelva && { yleSelva }),
      withCredentials: yleTunnusSDKExists() || isYleEmbed()
    },
    url: recommendationsUrl(programId)
  };
};

export interface Recommendation {
  id: string;
  description?: string;
  title?: string;
  image?: ImageObject;
  url: string;
  reference_item?: ReferenceItem;
}

export const fetchRecommendations = async (
  programId: string,
  language: string
): Promise<Recommendation[]> => {
  try {
    return getJson<{ data: Recommendation[] }>(
      queryOptions(programId, getLanguageCode(language))
    ).then(r => r.data);
  } catch (e) {
    return [];
  }
};
